<template>
	<div class="userList column-me">
		<div class="card-view column-me">
			<div class="card-title">代理商列表</div>
			<div class="row-me row-center">
				<div class="width300 demo-input-size">
					<el-input placeholder="代理名称/联系人/电话"  style="width: 100%;" v-model="keyword" :prefix-icon="Search"></el-input>
				</div>
				<el-form-item label="代理状态"  class="margin-left30 margin-top20 width300">
					<el-select v-model="isStatus" placeholder="代理状态">
						<el-option
							v-for="item in statusSearch" 
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="地区"  class="margin-left30 margin-top20 width400">
					<el-cascader
						style="width: 350px;"
					    v-model="area_id"
					    :options="regionOption"
						:props="{ checkStrictly: true }"
					    @change="agentAreaChange"></el-cascader>
				</el-form-item>
				<el-button class="margin-left20" type="primary" size="mini " @click="clickSearch" >搜索</el-button>
				<el-button size="mini " @click="clickClear" >重置</el-button>
				<el-button type="danger" size="mini " @click="clickAdd" >新增</el-button>
			</div>
			<div class="column-me flex1 overflow-auto">
				<div class="flex1 overflow-auto">
					<el-table :data="tableData" border v-loading="loading" stripe="true" size="mini " style="width: 100%" height="100%">
						<el-table-column prop="lecturer_name" label="代理名称" width="150" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="username" label="联系人" width="120" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="phone" label="电话" width="120" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="regionText" label="地区" width="200" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column  label="兑换码" width="300" align="center" show-overflow-tooltip>
							<el-table-column prop="redemption_all" label="总数" align="center" show-overflow-tooltip></el-table-column>
							<el-table-column prop="redemption_use" label="未使用" align="center" show-overflow-tooltip></el-table-column>
							<el-table-column prop="redemption_unused" label="已使用" align="center" show-overflow-tooltip></el-table-column>
							<el-table-column prop="redemption_expired" label="已过期" align="center" show-overflow-tooltip></el-table-column>
						</el-table-column>
						<el-table-column prop="studentNumber" label="学生数量" width="100" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="refundNumber" label="退费课程数量" width="80" align="center" show-overflow-tooltip>
							<template #default="scope">
								<el-button size="small" @click="specialRefundList(scope.row.id)" type="primary">{{scope.row.refundNumber}}</el-button>
							</template>
						</el-table-column>
						<el-table-column prop="explain" label="代理说明" width="200" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="introduction" label="简介" width="200" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column label="账户状态" width="100" align="center" show-overflow-tooltip>
							<template #default="scope">
								{{ scope.row.status == 1 ? '正常' : '禁用' }}
							</template>
						</el-table-column>
						<el-table-column prop="add_time" width="150" label="添加时间" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column label="操作" width="300" align="center" show-overflow-tooltip fixed="right">
							<template #default="scope">
								<div class="row-me center-all">
									<el-button type="primary" size="small " @click="redemption(scope.row)" >兑换码</el-button>
									<el-button type="success" plain size="small " @click="pwEdit(scope.row)" >重置密码</el-button>
									<el-button size="small " @click="clickEdit(scope.row)" >修改</el-button>
									<el-button type="danger" size="small " @click="clickDel(scope.row)" >删除</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="margin-top20">
					<el-pagination @current-change="handleCurrentChange" background :current-page.sync="pageNo"
                         layout="total, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
	<!-- 代理商信息修改界面 -->
	<el-dialog title="代理商信息修改" v-model="dataInfoEdit" width="1000px" top="10vh" :destroy-on-close="true">
	    <div class="padding-left80">
	        <div class="row-me row-center margin-top20">
	        	<div class="left-title"><span class="red-star">*</span>代理名称：</div>
	        	<div class="width500">
	        		<el-input placeholder="请输入" style="width: 100%;" clearable v-model="editInfo.lecturer_name"></el-input>
	        	</div>
	        </div>
	        <div class="row-me row-center margin-top20">
	        	<div class="left-title"><span class="red-star">*</span>联系人：</div>
	        	<div class="width500">
	        		<el-input placeholder="请输入" style="width: 100%;" clearable v-model="editInfo.username"></el-input>
	        	</div>
	        </div>
	        <div class="row-me row-center margin-top20">
	        	<div class="left-title"><span class="red-star">*</span>手机号码：</div>
	        	<div class="width500">
	        		<el-input placeholder="请输入" disabled="true" style="width: 100%;" clearable v-model="editInfo.phone"></el-input>
	        	</div>
	        </div>
	        <div class="row-me row-center margin-top20">
	        	<div class="left-title"><span class="red-star">*</span>代理地区：</div>
				<div class="width500">
					<el-cascader
						style="width: 500px;"
					    v-model="editInfo.region"
					    :options="regionOption"
					    @change="areaSelected"
						filterable
						clearable>
					</el-cascader>
				</div>
	        </div>
	        <div class="row-me row-center margin-top20">
	        	<div class="left-title">代理说明：</div>
	        	<div class="width500">
	        		<el-input placeholder="请输入" style="width: 100%;" clearable v-model="editInfo.explain"></el-input>
	        	</div>
	        </div>
	        <div class="row-me row-center margin-top20">
	        	<div class="left-title">代理简介：</div>
	        	<div class="width500">
	        		<el-input type="textarea" placeholder="请输入" style="width: 100%;" clearable v-model="editInfo.introduction"></el-input>
	        	</div>
	        </div>
			<div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>代理商状态：</div>
				<div class="width500">
					<el-select v-model="editInfo.status" placeholder="账户状态">
						<el-option 
							v-for="item in statusOption" 
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
			</div>
	        <div class="row-me flex-end1 margin-top50">
				<el-button @click="dataInfoEdit=false">取消</el-button>
				<el-button type="primary" @click="clickSave">确定</el-button>
	        </div>
	    </div>
	</el-dialog>
	<!-- 代理商信息添加 -->
	<el-dialog title="代理商信息添加界面" v-model="dataInfoAdd" width="950px" top="10vh" :destroy-on-close="true">
	    <div class="padding-left80">
	        <div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>代理名称：</div>
				<div class="width500">
					<el-input placeholder="请输入" style="width: 100%;" clearable v-model="addInfo.lecturer_name"></el-input>
				</div>
			</div>
			<div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>联系人：</div>
				<div class="width500">
					<el-input placeholder="请输入" style="width: 100%;" clearable v-model="addInfo.username"></el-input>
				</div>
			</div>
			<div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>手机号码：</div>
				<div class="width500">
					<el-input placeholder="请输入" style="width: 100%;" clearable v-model="addInfo.phone"></el-input>
				</div>
			</div>
			<div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>登陆密码：</div>
				<div class="width500">
					<el-input placeholder="请输入" style="width: 100%;" clearable v-model="addInfo.pwd"></el-input>
				</div>
			</div>
			<div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>重复密码：</div>
				<div class="width500">
					<el-input placeholder="请输入" style="width: 100%;" clearable v-model="addInfo.pwd_repeat"></el-input>
				</div>
			</div>
			<div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>代理地区：</div>
				<div class="width500">
					<el-cascader
						style="width: 500px;"
						placeholder="地区选择（可搜索）"
					    v-model="addInfo.region"
					    :options="regionOption"
					    @change="areaSelected"
						filterable
						clearable>
					</el-cascader>
					<!-- <el-input placeholder="请输入" style="width: 100%;" clearable v-model="addInfo.region"></el-input> -->
				</div>
			</div>
			<div class="row-me row-center margin-top20">
				<div class="left-title">代理说明：</div>
				<div class="width500">
					<el-input placeholder="请输入" style="width: 100%;" clearable v-model="addInfo.explain"></el-input>
				</div>
	        </div>
			<div class="row-me row-center margin-top20">
				<div class="left-title">代理简介：</div>
				<div class="width500">
					<el-input type="textarea" placeholder="请输入" style="width: 100%;" clearable v-model="addInfo.introduction"></el-input>
				</div>
			</div>
	        <div class="row-me flex-end1 margin-top50">
				<el-button @click="dataInfoAdd=false">取消</el-button>
				<el-button type="primary" @click="addClickSave">确定</el-button>
	        </div>
	    </div>
	</el-dialog>
	<!-- 兑换码信息列表界面 -->
	<el-dialog :title="lecturer_name" v-model="codeAgentInfo" width="1200px" top="5vh" :visible.sync="codeAgentInfoStatus" @close="codeAgentInfoClosed" :destroy-on-close="true">
	    <div class="padding-left0">
	        <div class="flex1 overflow-auto">
				<div class="row-me row-center padding-bottom10">
					<el-button type="danger" size="mini " @click="codeClickAdd" >新增</el-button>
				</div>
	        	<el-table :data="codeTableData" border v-loading="loading" stripe="true" size="medium" style="width: 100%" height="100%">
					<el-table-column prop="mold" label="激活码类型" align="center" show-overflow-tooltip>
						<template #default="scope">
							<el-tag v-if="scope.row.mold == 1" effect="dark" type="danger">主科兑换码</el-tag>
							<el-tag v-if="scope.row.mold == 2" effect="dark">副科兑换码</el-tag>
						</template>
					</el-table-column>
	        		<el-table-column prop="code" label="兑换码" align="center" show-overflow-tooltip></el-table-column>
	        		<el-table-column prop="status_text" label="状态" align="center" show-overflow-tooltip>
						<template #default="scope">
							<el-tag v-if="scope.row.status == 1" effect="dark" type="success">未使用</el-tag>
							<el-tag v-if="scope.row.status == 2" effect="dark" type="danger">已使用</el-tag>
							<el-tag v-if="scope.row.status == 3" effect="dark" type="info">已过期</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="special_title" label="兑换课程" align="center" show-overflow-tooltip></el-table-column>
					<el-table-column prop="user_nickname" label="学员名称" align="center" show-overflow-tooltip></el-table-column>
	        		<el-table-column prop="start_time" label="有效期开始时间" align="center" show-overflow-tooltip></el-table-column>
	        		<el-table-column prop="end_time" label="有效期结束时间" align="center" show-overflow-tooltip></el-table-column>
	        		<el-table-column label="操作" align="center" show-overflow-tooltip fixed="right">
	        			<template #default="scope">
							<div class="row-me center-all">
	        					<el-button type="danger" size="small " @click="codeClickDel(scope.row)" >删除</el-button>
	        				</div>
						</template>
	        		</el-table-column>
	        	</el-table>
	        </div>
	        <div class="margin-top20">
	        	<el-pagination @current-change="codeHandleCurrentChange" background :current-page.sync="codePageNo"
	                layout="total, prev, pager, next, jumper" :total="codeTotal">
	        	</el-pagination>
	        </div>
	    </div>
	</el-dialog>
	<!-- 兑换码信息添加 -->
	<el-dialog title="兑换码信息添加" v-model="codeInfoAdd" width="950px" top="10vh" :showClose="false" :destroy-on-close="true">
		<div class="padding-left80">
			<div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>激活码类型：</div>
				<div class="width500">
					<el-radio v-model="codeAddInfoArr.mold" :label="1">主科</el-radio>
					<el-radio v-model="codeAddInfoArr.mold" :label="2">副科</el-radio>
				</div>
			</div>
		    <div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>创建数量：</div>
				<div class="width500">
					<el-input-number size="mini" :min="1" v-model="codeAddInfoArr.code_num"></el-input-number>
				</div>
			</div>
			<div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>有效期开始：</div>
				<div class="width500">
					<el-date-picker 
					placeholder="选择日期" 
					size="mini" 
					type="date"
					style="width: 100%;" 
					clearable 
					v-model="codeAddInfoArr.start_time"></el-date-picker>
				</div>
			</div>
			<div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>有效期结束：</div>
				<div class="width500">
					<el-date-picker placeholder="选择日期" type="date" style="width: 100%;" clearable v-model="codeAddInfoArr.end_time"></el-date-picker>
				</div>
			</div>
			
		    <div class="row-me flex-end1 margin-top50">
				<el-button @click="codeInfoAddClose">取消</el-button>
				<el-button type="primary" @click="addCodeClickSave">确定</el-button>
		    </div>
		</div>
	</el-dialog>
</template>
<script>
import {Plus,Search} from "@element-plus/icons";
import { regionOption } from '../../assets/js/citys.js';
export default {
  components: {Plus,Search,regionOption},
  data() {
    return {
		regionOption:'',
		keyword: '',
		area_id:'',
		pageNo: 1,
		total: 0,
		loading:false,
		tableData: [],
		codeAgentInfoStatus:false,
		codePageNo:1,
		codeTotal:0,
		codeTableData:[],
		codeAgentId:0,
		codeAddInfoArr:{
			id:'',
			mold:1,
			code_num:'',
			start_time:'',
			end_time:''
		},
		lecturer_name:'', //兑换码列表 代理商信息
		isStatus:'',
		editInfo:{
			id: '',
			lecturer_name: '',
			username: '',
			phone: '',
			explain: '',
			introduction: '',
			region: '',
			status: ''
		},
		addInfo:{
			id: '',
			lecturer_name: '',
			username: '',
			phone: '',
			explain: '',
			introduction: '',
			region: '',
			pwd:'',
			pwd_repeat:''
		},
		statusOption:[{
			value: 1,
			label: '正常',
		},{
			value: 2,
			label: '禁用',
		}],
		statusSearch:[{
			value: 1,
			label: '正常',
		},{
			value: 2,
			label: '禁用',
		}],
		dataInfoEdit:false,
		dataInfoAdd:false,
		codeAgentInfo:false,
		codeInfoAdd:false,
    }
  },
  // 侦听器
  watch: {},
  // 计算属性
  computed: {
    Search() {
      return Search
    }
  },
  // html加载完成之前
  created() {
	this.regionOption = regionOption;
    this.clickSearch()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    clickSearch() {
      this.pageNo = 1
      this.getData()
    },
    clickClear() {
      this.keyword = ''
      this.isStatus = ''
	  this.area_id = ''
      this.clickSearch()
    },
    //table信息修改获取
    clickEdit(item) {
		this.$post('/admin/agentInfo', {
		  id: item.id
		}).then((res) => {
		  if (res) {
		    this.editInfo = res.data;
		    this.dataInfoEdit = true;
		  }
		}).catch((error) => {
		  console.log(error)
		})
    },
	//table信息修改保存
	clickSave(){
		this.$post('/admin/agentInfoAdd', {
			id:this.editInfo.id,
			lecturer_name:this.editInfo.lecturer_name,
			username:this.editInfo.username,
			phone:this.editInfo.phone,
			explain:this.editInfo.explain,
			introduction:this.editInfo.introduction,
			region:this.editInfo.region
			
		}).then((res) => {
			if (res) {
				this.getData();
				this.dataInfoEdit = false;
				this.$message.success('修改成功');
			}
		}).catch((error) => {
			console.log(error)
		})
	},
	clickAdd(){
		this.dataInfoAdd = true;
	},
	//列表分页
	handleCurrentChange(pageNo) {
	    this.pageNo = pageNo
	    this.getData()
	},
	//地区选择
	areaSelected(value){
		this.addInfo.region = value;
		this.editInfo.region = value;
	},
	agentAreaChange(value){
		if(value.length == 1){
			this.area_id = value[0]; 
		}else if(value.length == 2){
			this.area_id = value[1]; 
		}else if(value.length == 3){
			this.area_id = value[2]; 
		}
	},
	//新增信息保存
	addClickSave(){
		this.$post('/admin/agentInfoAdd', {
			lecturer_name:this.addInfo.lecturer_name,
			username:this.addInfo.username,
			phone:this.addInfo.phone,
			explain:this.addInfo.explain,
			introduction:this.addInfo.introduction,
			region:this.addInfo.region,
			pwd:this.addInfo.pwd,
			pwd_repeat:this.addInfo.pwd_repeat
		}).then((res) => {
			if (res) {
				this.getData();
				this.dataInfoAdd = false;
				this.$message.success('添加成功')
			}
		}).catch((error) => {
			console.log(error)
		})
	},
	//删除
	clickDel(item) {
		this.$confirm("您确定删除吗？删除后无法恢复！", "温馨提示", {
		    confirmButtonText: "确定",
		    cancelButtonText: "取消",
		    type: "warning",
		}).then(() => {
		    this.$post('/admin/agentInfoDel', {
		        id: item.id
		    }).then((res) => {
		        if (res) {
		            this.$message.success('删除成功')
		            this.getData()
		        }
		    }).catch((error) => {
		        console.log(error)
		    })
		}).catch((error) => {
				console.log(error)
		});	
	},
	//查看代理商兑换码信息
	redemption(item){
		this.codeAgentId = item.id;
		this.codeAddInfoArr.id = item.id;
		this.lecturer_name = "代理商【" + item.lecturer_name + "】兑换码信息列表";
		this.codeGetData();
		this.codeAgentInfo = true;
	},
	
	//密码重置接口
	pwEdit(item){
		this.$confirm("确定重置密码？", "温馨提示", {
		    confirmButtonText: "确定",
		    cancelButtonText: "取消",
		    type: "warning",
		}).then(() => {
		    this.$post('/admin/agentResetPwd', {
		        id: item.id
		    }).then((res) => {
		        if (res) {
		            this.$confirm("重置成功，新密码【1234567】？", "温馨提示", {
		            	confirmButtonText: "确定",
		            	cancelButtonText: "取消",
		            	type: "warning",
					})
		        }
		    }).catch((error) => {
		        console.log(error)
		    })
		}).catch((error) => {
				console.log(error)
		});	
	},
    //table获取数据
    getData() {
		this.loading = true;
		//console.log(this.area_id);
		this.$post('/admin/agentInfoList', {
			keyword: this.keyword,
			status: this.isStatus,
			area_id:this.area_id,
			page: this.pageNo
		}).then((res) => {
			if (res) {
				this.total = res.data.all_info_num
				this.tableData = res.data.listInfo
				this.loading = false;
			}
		}).catch((error) => {
			console.log(error)
		})
    },
	//兑换码table获取数据
	codeGetData() {
		this.loading = true;
		this.$post('/admin/agentCodeList', {
			agent_id:this.codeAgentId,
			page: this.codePageNo
		}).then((res) => {
			console.log(res);
			if (res) {
				this.codeTotal = res.data.all_info_num
				this.codeTableData = res.data.listInfo
				this.loading = false;
			}
		}).catch((error) => {
			console.log(error)
		})
	},
	//监听兑换码列表窗口关闭
	codeAgentInfoClosed(val){
		console.log('对话框已关闭');
		this.getData();
		
	},
	//兑换码信息添加
	codeClickAdd(){
		this.codeInfoAdd = true;
		//this.loading = true;
	},
	//兑换码添加页面关闭事件
	codeInfoAddClose(){
		this.codeInfoAdd = false;
		this.codeAddInfoArr = {
			id:'',
			mold:1,
			code_num:'',
			start_time:'',
			end_time:''
		};
		this.loading = false;
	},
	//兑换码添加页面提交保存事件
	addCodeClickSave(){
		this.loading = true;
		this.$post('/admin/agentCodeAdd', {
			agent_id: this.codeAgentId,
			mold:this.codeAddInfoArr.mold,
			code_num: this.codeAddInfoArr.code_num,
			start_time: this.codeAddInfoArr.start_time,
			end_time: this.codeAddInfoArr.end_time
		}).then((res) => {
			if (res) {
				this.codeGetData();
				this.codeInfoAddClose();
				this.loading = false;
			}else{
				this.loading = false;
			}
		}).catch((error) => {
			console.log(error)
		});
	},
	//兑换码table表格分页切换
	codeHandleCurrentChange(codePageNo){
		this.codePageNo = codePageNo;
		this.codeGetData();
	},
	//兑换码信息删除
	codeClickDel(item){
		this.$confirm("您确定删除吗？删除后无法恢复！", "温馨提示", {
		    confirmButtonText: "确定",
		    cancelButtonText: "取消",
		    type: "warning",
		}).then(() => {
		    this.$post('/admin/agentCodeDel', {
		        id: item.id
		    }).then((res) => {
		        if (res) {
		            this.$message.success('删除成功')
		            this.codeGetData()
		        }
		    }).catch((error) => {
		        console.log(error)
		    })
		}).catch((error) => {
				console.log(error)
		});	
	},
	specialRefundList(id){
		this.$router.push({
			name:'specialRefundList',
			query:{
				id:id
			}
		})
	}
  },
}
</script>

<style lang="scss" scoped>
.userList {
  height: 100%;

  .img-header {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  .el-date-editor .el-input__inner {
    font-size: 14px !important;
  }
}
</style>
